import React, { useContext, memo } from 'react';
import { Nav } from 'react-bootstrap';
import ChatThread from './ChatThread';
import SimpleBarReact from 'simplebar-react';
import { ChatContext } from 'context/Context';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ChatFeatures from './ChatFeatures';

const ChatSidebar = ({ hideSidebar }) => {
  const { threads } = useContext(ChatContext);

  return (
    <div className={classNames('chat-sidebar bg-100', { 'start-0': hideSidebar })}>
      <div className="contacts-list">
        <SimpleBarReact style={{ height: '100%', minWidth: '65px' }}>
          <Nav className="border-0">
            <ChatFeatures index={-1} />
            {threads?.map((thread, index) => (
              <ChatThread thread={thread} index={index} key={thread?.id || 'chat' + index} />
            ))}
          </Nav>
        </SimpleBarReact>
      </div>
    </div>
  );
};

ChatSidebar.propTypes = {
  hideSidebar: PropTypes.bool
};

export default memo(ChatSidebar);